import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

/**
 * 发送短信
 * @param customerId
 * @param phone
 * @param templateCode
 * @param param
 * @param customerUserId
 */
export function sendSms(customerId, phone, templateCode, param, customerUserId) {
  return request({
    url: cmsServerContext + '/smsPlatform/sendSms',
    method: 'post',
    data: {"customerId": customerId, "phone": phone, "templateCode": templateCode, "param": param, "customerUserId": customerUserId}
  })
}

/**
 * 批量发送短信
 * @param condition
 */
export function sendBatchSms(condition) {
  return request({
    url: cmsServerContext + '/smsPlatform/sendBatchSms',
    method: 'post',
    data: condition
  })
}

/**
 * 查询短信模板
 * @param customerId
 * @param type
 */
export function queryTemplate(customerId, type) {
  return request({
    url: cmsServerContext + '/smsPlatform/queryTemplate',
    method: 'post',
    data: {"customerId": customerId, "type": type}
  })
}

/**
 * 查询短信折扣信息
 * @param customerId
 */
export function queryDiscount(customerId) {
  return request({
    url: cmsServerContext + '/smsPlatform/queryDiscount',
    method: 'post',
    data: {"customerId": customerId}
  })
}

/**
 * 查询短信剩余条数等信息
 * @param customerId
 * @param phone
 * @param templateType
 * @param startTime
 * @param endTime
 */
export function queryRemaining(customerId, phone, templateType, startTime, endTime) {
  return request({
    url: cmsServerContext + '/smsPlatform/queryRemaining',
    method: 'post',
    data: {"customerId": customerId, "phone": phone, "templateTypeList": templateType, "startTime": startTime, "endTime": endTime}
  })
}

/**
 * 分页查询短信发送记录
 * @param current
 * @param size
 * @param customerId
 * @param phone
 * @param userId
 * @param templateType
 * @param startTime
 * @param endTime
 * @param statusList
 */
export function querySmsRecord(current, size, customerId, phone, userId, templateType, startTime, endTime, statusList) {
  return request({
    url: cmsServerContext + '/smsPlatform/querySmsRecord',
    method: 'post',
    data: {"page": {current: current, size: size}, "condition": {customerId: customerId, phone: phone, userId: userId, templateTypeList: templateType, startTime: startTime, endTime: endTime, statusList: statusList}}
  })
}

/**
 * 充值短信条数
 * @param customerId
 * @param customerUserId
 * @param prepaidNum
 * @param prepaidType
 */
export function prepaidRemaining(customerId, customerUserId, prepaidNum, prepaidType) {
  return request({
    url: cmsServerContext + '/smsPlatform/prepaidRemaining',
    method: 'post',
    data: {"customerId": customerId, "customerUserId": customerUserId, "prepaidNum": prepaidNum, "prepaidType": prepaidType}
  })
}

/**
 * 分页查询短信充值记录
 * @param current
 * @param size
 * @param customerId
 * @param tradeNo
 * @param userId
 * @param prepaidTypeList
 * @param startTime
 * @param endTime
 * @param statusList
 */
export function queryPrepaidRecord(current, size, customerId, tradeNo, userId, prepaidTypeList, startTime, endTime, statusList) {
  return request({
    url: cmsServerContext + '/smsPlatform/queryPrepaidRecord',
    method: 'post',
    data: {"page": {current: current, size: size}, "condition": {customerId: customerId, id: tradeNo, operationId: userId, prepaidTypeList: prepaidTypeList, startTime: startTime, endTime: endTime, statusList: statusList}}
  })
}

/**
 * 查询充值结果(每条只返回一次)
 * @param customerId
 * @param status
 * @param operationId
 */
export function queryPrepaidResult(customerId, status, operationId) {
  return request({
    url: cmsServerContext + '/smsPlatform/queryPrepaidResult',
    method: 'post',
    data: {"customerId": customerId, "status": status, "operationId": operationId}
  })
}